import {Component, Input} from '@angular/core';

@Component({
  selector: 'gp-card',
  template: `
    <div [ngClass]="{ 'error': hasError }" class="box m-x-sm card-box">
      <div class="box-header">
        <ng-content select="[card-title]"></ng-content>
      </div>
      <div class="box-body">
        <ng-content select="[card-body]"></ng-content>
      </div>
    </div>
  `,
})
export class GpCardComponent {

  @Input()
  public hasError = false;

}
